<template>
	<n-card
		style="max-width: 800px; min-width: 260px"
		title="Просмотр логов"
		:bordered="false"
		size="huge"
		role="dialog"
		aria-modal="true"
	>
		<n-data-table
			:max-height="500"
			:scroll-x="700"
			:columns="[
				{
					title: 'Ошибка',
					key: 'title' 
				}, {
					title: 'Время',
					key: 'time' 
				}
			]"
			:data="state.logs"
			:bordered="false"
		/>
		<n-button style="margin-top: 20px"
			@click="emit('modalclose')">
			Закрыть
		</n-button>
	</n-card>
</template>

<script setup>

import { reactive, defineEmits, onMounted } from "vue"
import { useMessage } from "naive-ui"
import { useStore } from "vuex"

const emit = defineEmits(["modalclose"])

const message = useMessage()
const store = useStore()


const state = reactive({
	selected_user: null,
	logs: []
})


const getAll = async() => {
	const response = await fetch(`${store.state.backend}/users/getlogs`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ token: store.state.admin.token })
	})
	if (response.ok) {
		const data = await response.json()
		for (let i = 0; i < data.logs.length; i++) {
			const elem = data.logs[i]
			state.logs.push({
				title: elem.title,
				type: elem.type,
				user: elem.user,
				time: String(new Date(elem.datetime).toLocaleString()) 
			})
		}
	} else {
		try {
			const data = await response.json()
			message.error(`Не удалось загрузить логи. ${data.reason}`)
		} catch {
			message.error("Не удалось загрузить логи")
		}
	}
}


onMounted(() => {
	getAll()
})

</script>